export const wrapupState = (state = {}, action) => {
  if (action.type === 'UPDATE_WRAPUP') {
    const newState = { ...state, ...action.wrapupState };

    return newState;
  }

  return state;
};
